module.exports = __webpack_public_path__ + "img/dll.21736fc.svg";